import { Link } from 'react-router-dom';

export default function ForbiddenPage(): JSX.Element {
  return (
    <div className="grid min-h-[60vh] place-items-center px-6 py-12">
      <div className="w-full max-w-md rounded-card border border-line bg-white p-8 text-center shadow-soft">
        <p className="font-display text-xs font-bold uppercase tracking-wider text-gold-700">
          Erreur 403
        </p>
        <h1 className="mt-2 font-display text-2xl font-extrabold text-navy-700">
          Accès refusé
        </h1>
        <p className="mt-3 font-sans text-sm text-sub">
          Votre rôle ne permet pas d&rsquo;accéder à cette section de la console.
        </p>
        <Link
          to="/dashboard"
          className="mt-6 inline-flex items-center gap-2 rounded-xl bg-navy-700 px-5 py-2.5 font-display text-sm font-bold text-white hover:bg-navy-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-500 focus-visible:ring-offset-2"
        >
          Retour au tableau de bord
        </Link>
      </div>
    </div>
  );
}
